import type { NodeCluster, OrbitalTone } from "../domain/mesh";

export const celestialTheme = {
  clusters: {
    core: { primary: "#dbe7ff", secondary: "#79a6ff", core: "#fff9e9" },
    projects: { primary: "#f0c6ff", secondary: "#8fb6ff", core: "#fff5ea" },
    memory: { primary: "#9cf6ea", secondary: "#95bcff", core: "#fff8ef" },
    infrastructure: { primary: "#8fb8ff", secondary: "#73f1ff", core: "#f4f4f4" },
    life: { primary: "#f9c49f", secondary: "#f0a6d9", core: "#fff5e9" },
  } satisfies Record<NodeCluster, { primary: string; secondary: string; core: string }>,
  orbitals: {
    core: { primary: "#d8dfff", secondary: "#9bbdff", core: "#fff7ef" },
    infra: { primary: "#a4d1ff", secondary: "#7ffff5", core: "#eef5ff" },
    memory: { primary: "#d9beff", secondary: "#ffb6d8", core: "#fff6ff" },
    compute: { primary: "#f4dcab", secondary: "#e1b9ff", core: "#fff7e2" },
    signal: { primary: "#b5f2e8", secondary: "#9ac2ff", core: "#f4fff7" },
  } satisfies Record<OrbitalTone, { primary: string; secondary: string; core: string }>,
  status: { warning: "#ffc6ae", draft: "#b9c0c3" },
  background: "#05060a",
  edges: { idle: "#cbd5d5", active: "#dce7ee" },
  guides: { idle: "#c4d4ef", active: "#f0f5ff" },
  pulse: "#f5f2d8",
} as const;
